<div class="lvi-content">
    <div class="avatar">
        <i class="material-icons-outlined">hub</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="extraOptions.parent.openConfig(data)">{{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="data.codeClient">
                <strong [translate]="'admin.voyages.travelhub.travelhub.codeClient'"></strong>
                <span>{{ data.codeClient }}</span>
            </li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button [matMenuTriggerFor]="listeActions">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #listeActions="matMenu">
            <button mat-menu-item (click)="copyConfig()" translate="global.actions.dupliquer"></button>
            <button mat-menu-item (click)="deleteConfig()" translate="global.actions.supprimer"></button>
        </mat-menu>
    </div>
</div>
